import type { FlagDefinition, FlagValueOf } from '@ringba/config/flags';
import type { IEvent } from '@zajno/common/observing/event';
import type { ISystemFlagsClient, SettleResult, SystemFlagsContext } from './types';

/**
 * Forwards every {@link ISystemFlagsClient} member to the wrapped client.
 * A subclass overrides only the members it changes.
 */
export class DelegatingFlagsClient implements ISystemFlagsClient {
  protected readonly _client: ISystemFlagsClient;

  constructor(client: ISystemFlagsClient) {
    this._client = client;
  }

  get onChanged(): IEvent<void> {
    return this._client.onChanged;
  }

  get isSettled(): boolean {
    return this._client.isSettled;
  }

  get<F extends FlagDefinition>(flag: F): FlagValueOf<F> {
    return this._client.get(flag);
  }

  setContext(context: SystemFlagsContext): void {
    this._client.setContext(context);
  }

  start(): void {
    this._client.start();
  }

  whenSettled(): Promise<SettleResult> {
    return this._client.whenSettled();
  }

  dispose(): void {
    this._client.dispose();
  }
}
